
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiArrowRightGoogle as ObiArrowRightGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-arrow-right-google.js';
 
 
 

 
 export const ObiArrowRightGoogle = createComponent({
   react: React,
   tagName: 'obi-arrow-right-google',
   elementClass: ObiArrowRightGoogleElement,
   events: {
     
   }
  });
 
 